import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  Observable,
  Operation
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, path, extensions }) => {
      if (extensions && extensions.code === "UNAUTHENTICATED") {
        localStorage.removeItem("token");
        window.location.assign("/login?expired=true");
      }
      console.error(`[GraphQL Error]: ${message} on operation: ${path}`);
    });
  }

  if (networkError) {
    console.error(`[Network Error]: ${networkError}`);
  }
});

const request = (operation: Operation): void => {
  const token = "Bearer " + localStorage.getItem("token");

  operation.setContext({
    headers: {
      Authorization: token
    }
  });
};

const requestLink = new ApolloLink(
  (operation, forward) =>
    new Observable(observer => {
      let handle: ZenObservable.Subscription;

      Promise.resolve(operation)
        .then(oper => request(oper))
        .then(() => {
          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer)
          });
        })
        .catch(observer.error.bind(observer));

      return () => {
        if (handle) {
          handle.unsubscribe();
        }
      };
    })
);

const logLink = new ApolloLink((operation, forward) => {
  if (operation.operationName !== "TokenExpirationTime") {
    localStorage.setItem("lastActivity", String(new Date()));
  }
  return forward(operation);
});

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_GRAPHQL_URI
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([errorLink, requestLink, logLink, httpLink])
});

export default client;
